const getUrlTokenExtracted = () => {
    const windowLocationHref = window.location.href;
    const urlPathChunks = windowLocationHref.split("/");
    return urlPathChunks[urlPathChunks.length-1];
}

export default getUrlTokenExtracted;